/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ChatAnswer,
  ChatError,
  ChatQuestionRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type chatCreateResponse200 = {
  data: ChatAnswer
  status: 200
}

export type chatCreateResponse400 = {
  data: ChatError
  status: 400
}

export type chatCreateResponse403 = {
  data: ChatError
  status: 403
}

export type chatCreateResponse500 = {
  data: ChatError
  status: 500
}

export type chatCreateResponseSuccess = (chatCreateResponse200) & {
  headers: Headers;
};
export type chatCreateResponseError = (chatCreateResponse400 | chatCreateResponse403 | chatCreateResponse500) & {
  headers: Headers;
};

export type chatCreateResponse = (chatCreateResponseSuccess | chatCreateResponseError)

export const getChatCreateUrl = () => {




  return `/api/v1/chat/`
}

/**
 * Generate a chat response
 */
export const chatCreate = async (chatQuestionRequest: ChatQuestionRequest, options?: RequestInit): Promise<chatCreateResponse> => {

  return customFetch<chatCreateResponse>(getChatCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(chatQuestionRequest)
  }
);}


